module.exports = __webpack_public_path__ + "media/newstyle/images/Logo_ESP_BRANCO-e0e525af72341e6347dc3f9be94e46af.png";